import { toast } from 'sonner';
import { CheckIcon } from '../assets/Check';
import { ClockIcon } from '../assets/Oclock';
import { XIcon } from '../assets/X';
import { InfoIcon } from '../assets/Info';

export const custonSooner = {
  success: (title: string, isPosition = false) =>
    toast(title, {
      unstyled: true,
      duration: 1000,
      position: isPosition ? 'top-center' : undefined,
      classNames: {
        toast: `flex flex-row items-center space-x-[10px] w-full p-2 rounded-[16px] shadow-lg bg-fill-overlay opacity-[0.64] backdrop-blur-lg ${
          isPosition ? 'mt-safe-top' : 'mb-20'
        }`,
        title: 'text-body-sm-medium  text-text-white',
        description: 'text-red-400',
        actionButton: 'bg-zinc-400',
        cancelButton: 'bg-orange-400',
        closeButton: 'bg-lime-400',
      },
      icon: (
        <div className="h-8 w-8 bg-brand-green rounded-md text-text-white flex justify-center items-center">
          <CheckIcon className="text-text-white" />
        </div>
      ),
    }),
  warning: (title: string, options?: { onClose?: () => void }) =>
    toast(title, {
      unstyled: true,
      duration: 1000,
      onAutoClose: options?.onClose,
      onDismiss: options?.onClose,
      classNames: {
        toast:
          'flex flex-row items-center space-x-[10px]  w-full px-4 py-3 mb-20 rounded-[16px] shadow-lg bg-fill-overlay opacity-[0.64] backdrop-blur-lg',
        title: 'text-body-base-medium  text-text-white',
        description: 'text-red-400',
        actionButton: 'bg-zinc-400',
        cancelButton: 'bg-orange-400',
        closeButton: 'bg-lime-400',
      },
      icon: (
        <div className="h-8 w-8 bg-text-primitive-yellow rounded-md text-text-white flex justify-center items-center">
          <ClockIcon />
        </div>
      ),
    }),
  error: (title: string) =>
    toast(title, {
      unstyled: true,
      // Дольше остальных: у ошибки нужно успеть прочитать, что случилось и
      // что делать дальше — секунды на это не хватает.
      duration: 3000,
      classNames: {
        toast:
          'flex flex-row items-center space-x-[10px]  w-full px-4 py-3 mb-20 rounded-[16px] shadow-lg bg-fill-overlay opacity-[0.64] backdrop-blur-lg',
        title: 'text-body-base-medium  text-text-white',
        description: 'text-red-400',
        actionButton: 'bg-zinc-400',
        cancelButton: 'bg-orange-400',
        closeButton: 'bg-lime-400',
      },
      icon: (
        <div className="h-8 w-8 bg-fill-danger rounded-md text-text-white flex justify-center items-center">
          <XIcon />
        </div>
      ),
    }),
  info: (title: string) =>
    toast(title, {
      unstyled: true,
      duration: 1000,
      classNames: {
        toast:
          'flex flex-row items-center space-x-[10px]  w-full px-4 py-3 mb-20 rounded-[16px] shadow-lg bg-fill-overlay opacity-[0.64] backdrop-blur-lg',
        title: 'text-body-base-medium  text-text-white',
        description: 'text-red-400',
        actionButton: 'bg-zinc-400',
        cancelButton: 'bg-orange-400',
        closeButton: 'bg-lime-400',
      },
      icon: (
        <div className="h-8 w-8 bg-fill-info rounded-md text-text-white flex justify-center items-center">
          <InfoIcon />
        </div>
      ),
    }),
};
